import Vue from 'vue'
import App from './App'
import router from './router'
import Antd from 'ant-design-vue'
import 'ant-design-vue/dist/antd.css'
import moment from 'moment';
import 'moment/locale/zh-cn';
moment.locale('zh-cn'); //设置语言 或 moment.lang('zh-cn');
Vue.prototype.$moment = moment;//挂载到当前vue实例对象
Vue.use(Antd)

Vue.config.productionTip = false


function IsNullByaddress(address) {
  return address && address!='null' ? address : ''
}
Vue.prototype.$IsNullByaddress = IsNullByaddress

router.afterEach((to,from,next)=>{
  window,scrollTo(0,0)
})
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js